import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesDeepDive = () => {
  const badges = [
    { name: 'Rookie Steps', icon: 'Star', color: '#FFD100' },
    { name: 'Explorer', icon: 'Compass', color: '#FF6B6B' },
    { name: 'Knowledge Master', icon: 'BookOpen', color: '#4ECDC4' },
    { name: 'Culture Keeper', icon: 'Heart', color: '#FF8B94' },
    { name: 'AI Power User', icon: 'Zap', color: '#A8E6CF' },
    { name: 'Team Player', icon: 'Users', color: '#FFD700' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#0B1220] to-[#0F0F11]">
      <div className="max-w-7xl mx-auto px-6">
        {/* AI Buddy Section */}
        <div className="mb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-[#FFD100]/10 border border-[#FFD100]/20 rounded-full px-4 py-2 mb-6">
                <Icon name="MessageCircle" size={16} color="#FFD100" />
                <span className="text-[#FFD100] text-sm font-semibold">AI BUDDY (BEE ASSISTANT)</span>
              </div>
              <h2 className="text-5xl font-bold text-white mb-6">
                Your 24/7 Context-Aware<br />
                <span className="text-[#FFD100]">HR Assistant</span>
              </h2>
              <div className="space-y-4 text-white/70">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#FFD100]/20 rounded-full flex items-center justify-center mt-1">
                    <Icon name="Check" size={14} color="#FFD100" strokeWidth={3} />
                  </div>
                  <p>Context-aware HR answers from Drive, SharePoint & Notion</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#FFD100]/20 rounded-full flex items-center justify-center mt-1">
                    <Icon name="Check" size={14} color="#FFD100" strokeWidth={3} />
                  </div>
                  <p>Policy lookup across all knowledge bases</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#FFD100]/20 rounded-full flex items-center justify-center mt-1">
                    <Icon name="Check" size={14} color="#FFD100" strokeWidth={3} />
                  </div>
                  <p>Automation: "Create Jira ticket", "Request access"</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-[#FFD100]/20 rounded-full flex items-center justify-center mt-1">
                    <Icon name="Check" size={14} color="#FFD100" strokeWidth={3} />
                  </div>
                  <p>Manager insights & team performance suggestions</p>
                </div>
              </div>
            </div>
            <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl p-8">
              <div className="bg-[#0B1220]/80 rounded-2xl p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-[#FFD100]/20 rounded-full flex items-center justify-center">
                    <Icon name="User" size={16} color="#FFD100" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white/90 text-sm">What's the WiFi password?</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-[#4ECDC4]/20 rounded-full flex items-center justify-center">
                    <Icon name="MessageCircle" size={16} color="#4ECDC4" />
                  </div>
                  <div className="flex-1">
                    <p className="text-white/90 text-sm">The WiFi password is "BeeWise2024" - I found this in the IT onboarding doc on SharePoint. 🐝</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Smart Onboarding Section */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#FFD100]/10 border border-[#FFD100]/20 rounded-full px-4 py-2 mb-6">
              <Icon name="Zap" size={16} color="#FFD100" />
              <span className="text-[#FFD100] text-sm font-semibold">SMART ONBOARDING & PLAYBOOKS</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Onboarding That Actually<br />
              <span className="text-[#FFD100]">Gets Things Done</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'Role-Based Journeys', icon: 'Target' },
              { title: 'Embedded Docs', icon: 'FileText' },
              { title: 'Action Checklists', icon: 'CheckSquare' },
              { title: 'Training & Quizzes', icon: 'Award' }
            ]?.map((feature, index) => (
              <div key={index} className="backdrop-blur-sm bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-[#FFD100]/40 transition-all duration-300">
                <div className="w-12 h-12 bg-[#FFD100]/10 rounded-xl flex items-center justify-center mb-4">
                  <Icon name={feature?.icon} size={24} color="#FFD100" />
                </div>
                <h4 className="text-white font-bold mb-2">{feature?.title}</h4>
              </div>
            ))}
          </div>
        </div>

        {/* Gamification Section */}
        <div>
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#FFD100]/10 border border-[#FFD100]/20 rounded-full px-4 py-2 mb-6">
              <Icon name="Award" size={16} color="#FFD100" />
              <span className="text-[#FFD100] text-sm font-semibold">GAMIFICATION & BADGES</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Make Progress<br />
              <span className="text-[#FFD100]">Visible & Rewarding</span>
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {badges?.map((badge, index) => (
              <div
                key={index}
                className="group backdrop-blur-sm bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-[#FFD100]/40 hover:scale-105 transition-all duration-300 text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: `${badge?.color}20` }}>
                  <Icon name={badge?.icon} size={28} color={badge?.color} strokeWidth={2} />
                </div>
                <h4 className="text-white text-sm font-semibold">{badge?.name}</h4>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <div className="inline-block backdrop-blur-xl bg-[#FFD100]/10 border border-[#FFD100]/30 rounded-2xl p-6 shadow-2xl shadow-[#FFD100]/20">
              <p className="text-2xl font-bold text-white mb-2">🎉 You've earned the <span className="text-[#FFD100]">Rookie Steps</span> Badge!</p>
              <p className="text-white/70 text-sm">Keep going to unlock more achievements</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesDeepDive;